module.exports = __webpack_public_path__ + "static/media/ok.2186201e.wav";